import React, { useState } from 'react'
import { Link } from "gatsby"
import homeLink from '../../../shared/utils/siteUrl'

import './header.scss'

// Images
import LogoIngennio from '../../../assets/images/home/LOGO-INNGENIO.svg'

const Header = (props) => {

  const { isMobile } = props
  const [showMenu, setShowMenu] = useState(false)

  return (
    <header className="f-inngenio-header">
      {
        isMobile
          ?
          <div className="f-container-menu-mobile">
            <div className="f-container-menu-mobile__header">
              <button className="f-container-button-menu" onClick={e => setShowMenu(true)}>
                <div className="f-line-menu"></div>
                <div className="f-line-menu"></div>
                <div className="f-line-menu"></div>
              </button>
              <Link className="f-link-menu logo" to="/">
                <div className="f-link-menu-container">
                  <figure className="f-link-menu_image-logo">
                    <img src={LogoIngennio} alt="Logo Ingennio" />
                  </figure>
                </div>
              </Link>
            </div>
          </div>
          :
          null
      }

      <nav className={"f-inngenio-header-menu " + (isMobile ? showMenu ? 'f-menu-mobile show' : 'f-menu-mobile hide' : '')}>
        {
          isMobile
            ?
            <>
              <div className="f-container-close-button">
                <button className="f-container-button-close" onClick={e => setShowMenu(false)}>
                  x
                </button>
              </div>
              <div className="f-inngenio-header-menu__option">
                <Link 
                  className="f-link-menu" 
                  to="/" 
                  activeClassName="active-menu"
                  onClick={e => setShowMenu(false)}
                >
                  <div className="f-link-menu-container">
                    <div className="f-link-menu_image-icon home"></div>
                    <span className="f-link-menu_text">Home</span>
                  </div>
                </Link>
              </div>
            </>
            :
            <div className="f-inngenio-header-menu__option desktop">
              <Link className="f-link-menu logo" to="/">
                <div className="f-link-menu-container">
                  <figure className="f-link-menu_image-logo">
                    <img src={LogoIngennio} alt="Logo Ingennio" />
                  </figure>
                </div>
              </Link>
            </div>
        }

        <div className="f-inngenio-header-menu__option">
          <Link 
            className="f-link-menu" 
            to="/colaboracion-abierta" 
            activeClassName="active-menu"
            onClick={e => setShowMenu(false)}
          >
            <div className="f-link-menu-container">
              <div className="f-link-menu_image-icon colaboracion-abierta"></div>
              <span className="f-link-menu_text">Colaboración Abierta</span>
            </div>
          </Link>
        </div>
        <div className="f-inngenio-header-menu__option">
          <Link 
            className="f-link-menu" 
            to="/emprendimiento-corporativo" 
            activeClassName="active-menu"
            onClick={e => setShowMenu(false)}
          >
            <div className="f-link-menu-container">
              <div className="f-link-menu_image-icon emprendimiento-corporativo"></div>
              <span className="f-link-menu_text">Emprendimiento Corporativo</span>
            </div>
          </Link>
        </div>
        <div className="f-inngenio-header-menu__option">
          <Link 
            className="f-link-menu" 
            to="/capacidades-internas" 
            activeClassName="active-menu"
            onClick={e => setShowMenu(false)}
          >
            <div className="f-link-menu-container">
              <div className="f-link-menu_image-icon capacidades-internas"></div>
              <span className="f-link-menu_text">Capacidades Internas</span>
            </div>
          </Link>
        </div>
        <div className="f-inngenio-header-menu__option">
          <Link 
            className="f-link-menu" 
            to="/herramientas-para-innovar" 
            activeClassName="active-menu"
            onClick={e => setShowMenu(false)}
          >
            <div className="f-link-menu-container">
              <div className="f-link-menu_image-icon herramientas-innovar"></div>
              <span className="f-link-menu_text">Herramientas para Innovar</span>
            </div>
          </Link>
        </div>
        <div className="f-inngenio-header-menu__option">
          <Link 
            className="f-link-menu" 
            to="/lanzamientos-innovadores" 
            activeClassName="active-menu"
            onClick={e => setShowMenu(false)}
          >
            <div className="f-link-menu-container">
              <div className="f-link-menu_image-icon lanzamientos-innovadores"></div>
              <span className="f-link-menu_text">Innovaciones</span>
            </div>
          </Link>
        </div>
        <div className="f-inngenio-header-menu__option-return">
          {/* <button className="f-button-return" onClick={redirectConectate}>
            Volver a Conéctate
          </button> */}
        </div>
      </nav>
    </header>
  )
}

export default Header
